import { useEditSceneModalStateContext } from './EditSceneModalStateContext';

export default function useCanEditSlot() {
  const {
    state: { selectedSlotIndex },
  } = useEditSceneModalStateContext();

  return selectedSlotIndex >= 0;
}
